import { render, staticRenderFns } from "./Efficiency.vue?vue&type=template&id=274d27d1&scoped=true&"
import script from "./Efficiency.vue?vue&type=script&lang=js&"
export * from "./Efficiency.vue?vue&type=script&lang=js&"
import style0 from "./Efficiency.vue?vue&type=style&index=0&id=274d27d1&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "274d27d1",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VIcon})
